import React from 'react'
import Chart from 'react-apexcharts'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'

import theme from 'theme'

const LineChart = ({
  series,
  categories,
  colors,
  height = 360,
  curve = 'smooth',
  strokeWidth = 2,
  showMarkers = true,
  legendShow = true,
  legendPosition = 'bottom',
  xAxisTitle,
  yAxisTitle,
  id = 'lineChart',
}) => {
  const options = {
    chart: {
      id,
      type: 'line',
      fontFamily: 'Roboto',
      foreColor: theme.palette.dashboard.chart.label,
      toolbar: { show: false },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        dynamicAnimation: { enabled: true, speed: 350 },
      },
    },
    colors,
    stroke: {
      curve,
      width: strokeWidth,
    },
    markers: {
      size: showMarkers ? 4 : 0,
      strokeWidth: 0,
      hover: { size: 6 },
    },
    xaxis: {
      categories,
      title: {
        text: xAxisTitle,
        style: { fontWeight: 700, fontFamily: 'Roboto' },
      },
      labels: {
        style: { fontFamily: 'Roboto' },
      },
    },
    yaxis: {
      title: {
        text: yAxisTitle,
        style: { fontWeight: 700, fontFamily: 'Roboto' },
      },
      labels: {
        style: { fontFamily: 'Roboto' },
      },
    },
    legend: {
      show: legendShow,
      position: legendPosition,
      fontFamily: 'Roboto',
      fontSize: '11px',
      fontWeight: 500,
      itemMargin: { vertical: 4 },
    },
    grid: {
      borderColor: theme.palette.divider,
      padding: { right: 8, left: 8 },
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
    },
    dataLabels: { enabled: false },
  }

  return (
    <Box width="100%" height="100%">
      <Chart options={options} series={series} type="line" height={height} />
    </Box>
  )
}

LineChart.propTypes = {
  series: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(PropTypes.number).isRequired,
    }),
  ).isRequired,
  categories: PropTypes.array.isRequired,
  colors: PropTypes.arrayOf(PropTypes.string),
  height: PropTypes.number,
  curve: PropTypes.oneOf(['smooth', 'straight', 'stepline']),
  strokeWidth: PropTypes.number,
  showMarkers: PropTypes.bool,
  legendShow: PropTypes.bool,
  legendPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  xAxisTitle: PropTypes.string,
  yAxisTitle: PropTypes.string,
  id: PropTypes.string,
}

export default LineChart
